import React from "react";

const Footer = () => {
  return <div className="footer">Shane Lin 2023©</div>;
};

export default Footer;
